import React from "react";
import styles from "../styles/styles";
import AppHeader from "../components/AppHeader/AppHeader";
import { Button, Box, Typography, Paper } from '@mui/material';
import UserEmailDisplay from "../components/UserEmailDisplay/UserEmailDisplay";
function CarView(props) {

    const {
        GlobalOverlays,
        trainSelected,
        carSelected,
        carInfo,
        setCarSelected,
        setTrainSelected,
        setTrainInfo,
        setCarInfo,
        trains,
        lastUpdate,
        telemetryAlert,
        selectedParam,
        setSelectedParam,
        setTrainHistory,
        timeRange,
        setTimeRange,
        rangeError,
        loadingTrain,
        loadingChart,
        trainHistory,
        formatMetric,
        SmartChart,
        ParamAutocomplete,
        TimeRangeSelector,
        carAllowedParams,
        uniqueDisplayRows
    } = props;

    const currentTrain = trains.find(t => t.id === trainSelected);

    // apenas linhas do carro atual
    const carRows = uniqueDisplayRows.filter(row => row.carro === carSelected);

    return (
        <>
            {GlobalOverlays}
            <Box sx={styles.pageWrapper}>
                <Box component="main" sx={styles.mainContent}>
                    <Paper elevation={0} sx={{ ...styles.card, pl: 3, pr: 3, pt: 2, pb: 3 }}>
                        <UserEmailDisplay />


                        <div style={styles.detailHeader}>

                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    color: "#111827",
                                    lineHeight: 1.2
                                }}
                            >
                                {currentTrain?.name ??
                                    `Trem ${trainSelected} `} • Carro {carSelected}
                            </Typography>

                            {lastUpdate && (
                                <div
                                    style={{
                                        ...styles.lastUpdate,
                                        color:
                                            telemetryAlert === "critical"
                                                ? "#ff6b6b"
                                                : telemetryAlert === "warning"
                                                    ? "#f1c40f"
                                                    : "#6b7280"
                                    }}
                                >


                                    <span>Última atualização: {lastUpdate}</span>

                                    {telemetryAlert && (
                                        <span>
                                            {telemetryAlert === "critical"
                                                ? "🚨 sem telemetria há +10 minutos"
                                                : "⚠️ atraso +5 minutos"}
                                        </span>
                                    )}

                                </div>
                            )}

                            <Button
                                style={styles.backButton}
                                onClick={() => {
                                    setSelectedParam(null);
                                    setTrainHistory([]);
                                    setCarSelected(null);
                                }}
                            >
                                ⬅ Voltar aos carros
                            </Button>

                        </div>


                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns:
                                    "repeat(auto-fit,minmax(260px,1fr))",
                                gap: 2,
                                mb: 3
                            }}
                        >

                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #E5E7EB",
                                    borderRadius: 2
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Portas
                                </Typography>

                                <Typography
                                    variant="h5"
                                    sx={{
                                        mt: 1,
                                        fontWeight: 700,
                                        color:
                                            carInfo?.doorStatus === "Aberta"
                                                ? "#DC2626"
                                                : "#111827"
                                    }}
                                >
                                    {carInfo?.doorStatus ?? "--"}
                                </Typography>
                            </Paper>

                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #E5E7EB",
                                    borderRadius: 2
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Temperatura
                                </Typography>

                                <Typography
                                    variant="h5"
                                    sx={{
                                        mt: 1,
                                        fontWeight: 700
                                    }}
                                >
                                    {formatMetric(
                                        carInfo?.temperature,
                                        {
                                            decimals: 1,
                                            unit: "°C"
                                        }
                                    )}
                                </Typography>
                            </Paper>

                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #E5E7EB",
                                    borderRadius: 2
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Passageiros
                                </Typography>

                                <Typography
                                    variant="h5"
                                    sx={{
                                        mt: 1,
                                        fontWeight: 700
                                    }}
                                >
                                    {carInfo?.passengers ?? "--"}
                                </Typography>
                            </Paper>

                        </Box>

                        <div style={{ marginBottom: "20px" }}>

                            <TimeRangeSelector
                                timeRange={timeRange}
                                setTimeRange={setTimeRange}
                            />

                            <ParamAutocomplete
                                selectedParam={selectedParam}
                                allowedParams={carAllowedParams}
                                onSelect={(paramId) => {
                                    setSelectedParam(paramId);
                                    setTrainHistory([]);
                                }}
                            />

                        </div>

                        <div style={styles.mainChartContainer}>

                            {rangeError && (
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        borderRadius: 1,
                                        bgcolor: "#FEF2F2",
                                        border: "1px solid #FCA5A5",
                                        color: "#B91C1C"
                                    }}
                                >
                                    {rangeError}
                                </Box>
                            )}

                            {!loadingTrain && (
                                <SmartChart
                                    history={trainHistory}
                                    paramId={selectedParam}
                                    loading={loadingChart}
                                />
                            )}

                        </div>

                        <div style={styles.telemetryContainer}>

                            <h3 style={{ marginBottom: "10px" }}>
                                Telemetria do Carro
                            </h3>

                            <div style={styles.telemetryScroll}>


                                <table style={styles.telemetryTable}>


                                    <thead>

                                        <tr style={styles.telemetryHeaderRow}>
                                            <th>ID</th>
                                            <th>Categoria</th>
                                            <th>Timestamp</th>
                                            <th>Param</th>
                                            <th>Valor</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        {carRows.map(row => {

                                            const key =
                                                `${row.id} -${row.timestamp} -${row.carro} -${row.code} `;

                                            return (
                                                <tr
                                                    key={key}
                                                    style={{
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    <td>{row.id}</td>

                                                    <td>
                                                        {row.raw_category}
                                                    </td>

                                                    <td>
                                                        {new Date(
                                                            Number(row.timestamp)
                                                        ).toLocaleString("pt-BR")}
                                                    </td>

                                                    <td>{row.code}</td>

                                                    <td>{row.value}</td>
                                                </tr>
                                            );

                                        })}

                                    </tbody>

                                </table>

                            </div>

                        </div>


                    </Paper>
                </Box>
            </Box>

        </>
    );



}

export default CarView;